import {rupiah} from 'utils/formatter'
import styles from './Item.css'
import SetQuantityModal from 'components/receipt/refunds/SetQuantityModal'
import {connect} from 'react-redux'
import {formValueSelector} from 'redux-form'

class Item extends React.Component {
  constructor (props) {
    super(props)
    let amounts = {}
    for (var salesType in props.refundItems) {
      let amountST = props.refundItems[salesType].map((refundItem) => refundItem.refundAmount)
      amounts[salesType] = amountST
    }
    this.state = {amounts}
  }

  componentWillReceiveProps (nextProps) {
    let amounts = {}
    for (var salesType in nextProps.refundItems) {
      let amountST = nextProps.refundItems[salesType].map((refundItem) => refundItem.refundAmount)
      amounts[salesType] = amountST
    }
    this.setState({amounts})
  }

  render () {
    let {refundItems, setQuantity: {idx}} = this.props

    return (<div className='row'>
      <div className='col-md-12 item-to-refund'>
        <span className='pull-left'><label className='item-to-refund'>Item to Refund</label></span>
        {this._canSelectAll() && <span className='pull-right'>
          {!this._isSelectedAll() && <a className={styles['select-all']} onClick={this._onClickSelectAll}>Select All</a>}
          {this._isSelectedAll() && <a className={styles['select-all']} onClick={this._onClickDeselectAll}>Deselect All</a>}
        </span>}
      </div>

      <div className='col-md-12 visible-lg visible-md'>
        {this._renderNonMobileTable(refundItems)}
      </div>

      <div className='col-xs-12 visible-xs visible-sm'>
        {this._renderMobileTable(refundItems, idx)}
      </div>
      <SetQuantityModal onSubmit={this._onSubmitSetQuantity}
        refundItems={refundItems}
        onCancel={this._cancelSetQuantity}
        open={this.props.openSetQtyModal}
        />
    </div>)
  }

  _isSelectedAll = () => {
    return this.props.isSelectedAll()
  }

  _isChecked = (salesType, idx) => {
    return this.props.isChecked(salesType, idx)
  }

  _isRefunded = (salesType, idx) => {
    return this.props.isRefunded(salesType, idx)
  }

  _canBeRefunded = (salesType, idx) => {
    return this.props.canBeRefunded(salesType, idx)
  }

  _canSelectAll = () => {
    return this.props.canSelectAll()
  }

  _onClickCheck = (salesType, idx) => {
    return this.props.onClickCheck(salesType, idx)
  }

  _onClickSelectAll = (salesType, idx) => {
    return this.props.onClickSelectAll(salesType, idx)
  }

  _onClickDeselectAll = (salesType, idx) => {
    return this.props.onClickDeselectAll(salesType, idx)
  }

  _onClickIncreaseQty = (salesType, idx) => {
    return this.props.onClickIncreaseQty(salesType, idx)
  }

  _onClickDecreaseQty = (salesType, idx) => {
    return this.props.onClickDecreaseQty(salesType, idx)
  }

  _onChangeInputAmountRefunded = (salesType, idx, newValue) => {
    return this.props.onChangeInputAmountRefunded(salesType, idx, newValue)
  }

  _calculateItemPrice = (salesType, idx) => {
    return this.props.calculateItemPrice(salesType, idx)
  }
  _askSetQuantity = (idx, salesTypeName, refundAmount) => {
    return this.props.onAskSetQtyModal(idx, salesTypeName, refundAmount)
  }

  _cancelSetQuantity = () => {
    return this.props.onCancelSetQtyModal()
  }

  _onSubmitSetQuantity = (values) => {
    const {salesTypeName, idx, quantity} = values
    return this.props.onConfirmSetQtyModal(salesTypeName, idx, quantity)
  }

  _onClickCheckPromo = (refundItem) => {
    return this.props.onClickCheckPromo(refundItem)
  }

  _onClickIncreaseQtyPromo = (refundItem) => {
    return this.props.onClickIncreaseQtyPromo(refundItem)
  }

  _onClickDecreaseQtyPromo = (refundItem) => {
    return this.props.onClickDecreaseQtyPromo(refundItem)
  }

  _isPromoItem = (checkoutId) => {
    return this.props.isPromoItem(checkoutId)
  }

  _calculatePromoItemPrice = (refundItem) => {
    return this.props.calculatePromoItemPrice(refundItem)
  }

  _isFreeItem = (checkoutId) => {
    return this.props.isFreeItem(checkoutId)
  }

  _getPromoName = (refundItem) => {
    return this.props.getPromoName(refundItem)
  }

  _renderNonMobileTable = (refundItems) => {
    let items = []
    for (let salesType in refundItems) {
      var itemsPerSalesType = refundItems[salesType].map((refundItem, idx) => {
        let {itemName, itemVariantName, refundAmount} = refundItem

        // to handle promo item
        let isPromoItem = this._isPromoItem(refundItem.parentCheckoutId)
        let promoItemPrice = this._calculatePromoItemPrice(refundItem)
        let isFreeItem = this._isFreeItem(refundItem.parentCheckoutId)
        let promoName = this._getPromoName(refundItem)
        let shouldShowCheckbox = () => {
          let show = false
          if (isPromoItem) {
            show = !isFreeItem && refundItem.maxQuantity > 0 && promoItemPrice > 0
          } else {
            show = this._canBeRefunded(salesType, idx)
          }
          return show
        }

        return (
          <div key={idx} className={`row ${styles['separator']}`}>
            <div className='col-md-6 col-xs-7 qty-box-left' style={{border: 'none !important'}}>
              <div className='top-8 text-elipsis'>
                { itemName } { itemVariantName }
              </div>
              <p className={styles['refund-item-price']}>
                { !isPromoItem ? rupiah(this._calculateItemPrice(salesType, idx)) : isFreeItem ? 'FREE' : rupiah(promoItemPrice) }
              </p>
              {isPromoItem &&
                <p className={styles['refund-promo-name']}>
                  { isFreeItem ? `Reward - ${promoName}` : promoName }
                </p>
              }
            </div>
            <div className='col-xs-2 no-border quantity-refund-breakdown text-right visible-xs visible-sm'>
              <div className='input-group box-quantity-refund'>
                x {refundAmount}
              </div>
            </div>
            <div className={!this.props.showCheckbox
              ? 'col-md-6 col-xs-3'
              : `col-md-6 col-xs-3 ${styles['qty-checkbox']}`}>
              <div className={!this.props.showCheckbox
                ? `col-md-9 visible-lg visible-md no-border qty-box ${styles['padTop']}`
                : `col-md-9 visible-lg visible-md no-border ${styles['padTop-mrLeft']}`}>
                <div className={`input-group ${(shouldShowCheckbox()) ? (this._isRefunded(salesType, idx) ? styles['is-refunded'] : styles['is-not-refunded']) : styles['cannot-be-refunded']}`}>
                  <span className={`input-group-addon ${styles['add-qty-button']} ${(this._canBeRefunded(salesType, idx)) ? styles['can-be-refunded'] : styles['cannot-be-refunded']}`}
                    onClick={() => {
                      (!this._isChecked(salesType, idx) || !this._canBeRefunded(salesType, idx))
                      ? () => {}
                      : !isPromoItem ? this._onClickDecreaseQty(salesType, idx) : this._onClickDecreaseQtyPromo(refundItem)
                    }}>
                    <i className='fa fa-minus' />
                  </span>
                  <input
                    className={`form-control text-center ${styles['add-qty-input']}`}
                    disabled={!this._isChecked(salesType, idx) || !shouldShowCheckbox()}
                    value={this.state.amounts[salesType][idx]}
                    onChange={(e) => {
                      if (!isPromoItem) {
                        if (!isNaN(e.target.value)) {
                          this.state.amounts[salesType][idx] = e.target.value < 0 ? this.state.amounts[salesType][idx] : e.target.value
                          this.setState({amounts: this.state.amounts})
                        }
                      } else {
                        // amount can't be edited if the item is promo item
                        e.preventDefault()
                      }
                    }}
                    onBlur={(e) => { !isPromoItem ? this._onChangeInputAmountRefunded(idx, e.target.value) : e.preventDefault() }}
                  />
                  <span className={`input-group-addon ${styles['add-qty-button']} ${(this._canBeRefunded(salesType, idx)) ? styles['can-be-refunded'] : styles['cannot-be-refunded']}`}
                    onClick={() => {
                      (!this._isChecked(salesType, idx) || !this._canBeRefunded(salesType, idx))
                      ? () => {}
                      : !isPromoItem ? this._onClickIncreaseQty(salesType, idx) : this._onClickIncreaseQtyPromo(refundItem)
                    }}>
                    <i className='fa fa-plus' />
                  </span>
                </div>
              </div>
              <div className={!this.props.showCheckbox
                ? 'col-md-3 col-xs-12'
                : `col-md-3 col-xs-12 ${styles['right-checkbox']}`}>
                {shouldShowCheckbox() && <div className='checkbox-refund-breakdown no-border'>
                  <div className='top-8 checkbox-input pull-right'>
                    <div className={`checkbox pull-right checkbox-primary checkbox-circle ${styles['refund-checkbox']}`}>
                      <input
                        type='checkbox'
                        onClick={() => !isPromoItem ? this._onClickCheck(salesType, idx) : this._onClickCheckPromo(refundItem)}
                        checked={this._isChecked(salesType, idx)}
                      />
                      <label>&nbsp;</label>
                    </div>
                  </div>
                </div>}
              </div>
            </div>
          </div>
        )
      })
      if (this.props.isSalesType) {
        items.push(<div>
          <div className={styles['sales-type-header']}>
            {salesType}
          </div>
          {itemsPerSalesType}
        </div>)
      } else {
        items.push(<div>
          {itemsPerSalesType}
        </div>)
      }
    }
    return (<table className='table mk-table-summary table-truncate item-refund-breakdown'>
      {items.map((refundItem, idx) => {
        return refundItem
      })}
    </table>)
  }

  _renderMobileTable = (refundItems) => {
    let items = []

    for (let salesType in refundItems) {
      var itemsPerSalesType = refundItems[salesType].map((refundItem, idx) => {
        let {itemName, itemVariantName, refundAmount, salesTypeName} = refundItem

        // to handle promo item
        let isPromoItem = this._isPromoItem(refundItem.parentCheckoutId)
        let promoItemPrice = this._calculatePromoItemPrice(refundItem)
        let isFreeItem = this._isFreeItem(refundItem.parentCheckoutId)
        let promoName = this._getPromoName(refundItem)
        let shouldShowCheckbox = () => {
          let show = false
          if (isPromoItem) {
            show = !isFreeItem && refundItem.maxQuantity > 0 && promoItemPrice > 0
          } else {
            show = this._canBeRefunded(salesType, idx)
          }
          return show
        }

        return (
          <tr width='90%' key={idx} className={`box-item-name list-item-to-refund`} id={styles['item-mobi']}>
            <td className='name-item-refund no-padding' style={{border: 'none !important'}} onClick={(!this._isChecked(salesType, idx) || !this._canBeRefunded(salesType, idx)) ? () => {} : () => this._askSetQuantity(idx, salesTypeName, refundAmount)}>
              <div className='top-8 text-elipsis'>
                { itemName } { itemVariantName }
              </div>
              <p className={styles['refund-item-price']}>
                { !isPromoItem ? rupiah(this._calculateItemPrice(salesType, idx)) : isFreeItem ? 'FREE' : rupiah(promoItemPrice) }
              </p>
              {isPromoItem && <p className={styles['refund-promo-name']}>
                { isFreeItem ? `Reward - ${promoName}` : promoName }
              </p>}
              {!this.props.showCheckbox &&
                <div className={`input-group ${styles['is-not-refunded']} ${styles['cannot-be-refunded']}`}>
                  <span className={`input-group-addon ${styles['add-qty-button']} ${styles['cannot-be-refunded']}`}>
                    <i className='fa fa-minus' />
                  </span>
                  <input type='number'
                    className={`form-control text-center ${styles['add-qty-input']}`}
                    disabled={!this._isChecked(salesType, idx) || !shouldShowCheckbox()}
                    value={this.state.amounts[salesType][idx]}
                    onChange={(e) => {
                      if (!isPromoItem) {
                        this.state.amounts[salesType][idx] = e.target.value
                        this.setState({amounts: this.state.amounts})
                      } else {
                        e.preventDefault()
                      }
                    }}
                    onBlur={(e) => { !isPromoItem ? this._onChangeInputAmountRefunded(salesType, idx, e.target.value) : e.preventDefault() }}
                  />
                  <span className={`input-group-addon ${styles['add-qty-button']} ${styles['cannot-be-refunded']}`}>
                    <i className='fa fa-plus' />
                  </span>
                </div>
                }
            </td>
            {this.props.showCheckbox &&
              <td className='no-border quantity-refund-breakdown text-right visible-xs visible-sm' onClick={(!this._isChecked(salesType, idx) || !this._canBeRefunded(salesType, idx)) ? () => {} : () => this._askSetQuantity(idx, salesTypeName, refundAmount)}>
                <div className='input-group box-quantity-refund'>
                  x {refundAmount}
                </div>
              </td>}
            <td className='checkbox-refund-breakdown no-border'>
              {shouldShowCheckbox() && <div className='top-8 checkbox-input pull-right'>
                <div className={`checkbox pull-right checkbox-primary checkbox-circle ${styles['refund-checkbox']}`}>
                  <input
                    type='checkbox'
                    onClick={() => !isPromoItem ? this._onClickCheck(salesType, idx) : this._onClickCheckPromo(refundItem)}
                    checked={this._isChecked(salesType, idx)} />
                  <label>&nbsp;</label>
                </div>
                </div>}
            </td>
          </tr>
        )
      })
      if (this.props.isSalesType) {
        items.push(<div>
          <div className={styles['sales-type-header']}>
            {salesType}
          </div>
          {itemsPerSalesType}
        </div>)
      } else {
        items.push(<div>
          {itemsPerSalesType}
        </div>)
      }
    }

    return (<table className='table mk-table-summary table-truncate item-refund-breakdown item-refund-mobile'>
      {items.map((refundItem, idx) => {
        return refundItem
      })}
    </table>)
  }

}

Item.propTypes = {
  onAskSetQtyModal: React.PropTypes.func,

  onConfirmSetQtyModal: React.PropTypes.func,

  onCancelSetQtyModal: React.PropTypes.func,

  openSetQtyModal: React.PropTypes.bool,

  // canSelectAll() is whether the 'select all' or deselect all is enabled
  canSelectAll: React.PropTypes.func,

  // isChecked(idx) is whether item[idx] is checked (included in refund)
  isChecked: React.PropTypes.func,

  // isSelectedAll is whether all items is selected for refund
  isSelectedAll: React.PropTypes.func,

  // isRefunded(idx) is whether item[idx] can be refunded
  // where idx is array key (not item id!)
  isRefunded: React.PropTypes.func,

  // canBeRefunded(idx) is whethere item[idx] can be refunded
  // where idx is array key (not item id!)
  canBeRefunded: React.PropTypes.func,

  // onClickCheck(idx) is event listener when checkbox for specific item is checked
  // where idx is array key (not item id!)
  onClickCheck: React.PropTypes.func,

  // onClickSelectAll() is event listener when 'select all' button is clicked
  onClickSelectAll: React.PropTypes.func,

  // onClickDeselectAll() is event listener when 'deselect all' button is clicked
  onClickDeselectAll: React.PropTypes.func,

  // onClickIncreaseQty(idx) is event listener when + button on item is clicked
  onClickIncreaseQty: React.PropTypes.func,

  // onClickIncreaseQty(idx) is event listener when - button on item is clicked
  onClickDecreaseQty: React.PropTypes.func,

  // onChangeInputAmountRefunded(idx,newValue) is event listener when value of input amount refunded of a item is refunded
  // idx - array key
  // newValue new value
  onChangeInputAmountRefunded: React.PropTypes.func,

  // refundItems is array of items
  // where each of them contains {itemName, itemVariantName, refundAmount}
  refundItems: React.PropTypes.array,

  // calculateItemPrice(idx) is how much the item price
  calculateItemPrice: React.PropTypes.func,

  // true if the checkbox is showed
  showCheckbox: React.PropTypes.bool
}

Item.defaultProps = {
  isPromoItem: function () { return false },
  calculatePromoItemPrice: function () { return 0 },
  isFreeItem: function () { return false },
  getPromoName: function () { return '' }
}

const selector = formValueSelector('setQuantity')

function mapStateToProps (state) {
  return {
    setQuantity: {
      idx: selector(state, 'idx')
    }
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(Item)



// WEBPACK FOOTER //
// ./app/components/receipt/refunds/RefundBreakdownModal/Item/Item.js